module.exports = __webpack_public_path__ + "img/banner1.fde86b99.jpg";